import { render, staticRenderFns } from "./ProjectRegularTasks.vue?vue&type=template&id=3aef33e7&scoped=true&"
import script from "./ProjectRegularTasks.vue?vue&type=script&lang=js&"
export * from "./ProjectRegularTasks.vue?vue&type=script&lang=js&"
import style0 from "./ProjectRegularTasks.vue?vue&type=style&index=0&id=3aef33e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aef33e7",
  null
  
)

component.options.__file = "ProjectRegularTasks.vue"
export default component.exports